import {useQuery} from "@tanstack/react-query";
import {BackendApi} from "../api/api.ts";
import {BillDuplicateGroup} from "../components/specific/PossibleDuplicates/possibleDuplicates";

export const BILL_DUPLICATES_QUERY = 'bill-duplicates';

export function useBillDuplicates(api: BackendApi, billId: string | null) {
    return useQuery({
        queryKey: [BILL_DUPLICATES_QUERY, billId],
        queryFn: async ({signal}): Promise<BillDuplicateGroup> => {
            if (billId === null) {
                throw new Error('A bill id is required to load its duplicates');
            }
            return await api.withAbortSignal(signal).Partner__client__getBillDuplicates(billId);
        },
        enabled: billId !== null,
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 0,
    });
}
